import en from "./translations/en.json";
import cs from "./translations/cs-cz.json";
import de from "./translations/de-de.json";
import dk from "./translations/da-dk.json";
import es from "./translations/es-es.json";
import esmx from "./translations/es-mx.json";
import fi from "./translations/fi-fi.json";
import fr from "./translations/fr-fr.json";
import it from "./translations/it-it.json";
import ja from "./translations/ja-jp.json";
import ko from "./translations/ko-kr.json";
import nl from "./translations/nl-nl.json";
import no from "./translations/nb-no.json";
import pl from "./translations/pl-pl.json";
// import ptpt from "./translations/pt-pt.json";
import ptbr from "./translations/pt-br.json";
import ru from "./translations/ru-ru.json";
import sv from "./translations/sv-se.json";
import zhhans from "./translations/zh-hans.json";
import zhtw from "./translations/zh-tw.json";
export const i18nConfig = {
    defaultLocale: "en-us",
    messages: {
        "en": en,
        "en-us": en,
        "en-gb": en,
        "da-dk": dk,
        "de-de": de,
        "es-es": es,
        "es-mx": esmx,
        "fr-fr": fr,
        "it-it": it,
        "nl-nl": nl,
        "nb-no": no,
        "pl-pl": pl,
        "pt-br": ptbr,
        // "pt-pt": ptpt,
        "fi-fi": fi,
        "sv-se": sv,
        "cs-cz": cs,
        "ru-ru": ru,
        "ja-jp": ja,
        "ko-kr": ko,
        "zh-cn": zhhans,
        "zh-tw": zhtw,
    },
};
